import { sleep } from 'utils/sleep';

const exponentDelayFn = (attempts: number) => ~~(1 << attempts) * 1000;

export const retryAsync = async <T = unknown>(
  fn: () => Promise<T>,
  retries: number = 3,
  delay: number | ((attempt: number) => number) = exponentDelayFn
): Promise<T> => {
  let attempts = 0;
  while (attempts < retries) {
    try {
      return await fn();
    } catch (error) {
      attempts++;
      if (attempts >= retries) {
        throw error;
      }
      await sleep(typeof delay === 'function' ? delay(attempts) : delay);
    }
  }
  throw new Error('Unexpected error in retryAsync function');
};
